(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/models/wager.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const rulesRadio = svs.numbergames.game_model.rulesRadio;
svs.numbergames.game_model.models.Wager = svs.numbergames.core.NumbergamesModel.extend({
  defaults() {
    return {
      productId: '',
      rowPrice: 0,
      rowPriceMulti: 1,
      boards: undefined,
      numberOfValidBoards: 0,
      jokerRow: [],
      jokerPrice: 0,
      jokerIsValid: true,
      hasJoker: false,
      drawCount: '1',
      selectedDays: [],
      price: 0,
      isValid: false,
      isSyndicate: false,
      syndicateId: 0,
      isPackage: false,
      isSystem: false,
      isSingle: false,
      isSubscription: false,
      subscriptionId: undefined,
      packages: {},
      selectedPackage: 0,
      prolongedBet: undefined,
      numRowsExceedMax: false,
      tickets: undefined
    };
  },
  initialize(attrs) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    svs.numbergames.game_model.logger.debug('models.Wager initialize', this.attributes);
    this.storageKey = options.storageKey;
    this.setNumberOfValidBoards();
    this.calculatePrice();
    this.setValid();
    this.listenTo(this, 'change:drawCount', this.drawCountChanged);
    this.listenTo(this, 'change:jokerPrice', this.jokerPriceChanged);
    this.listenTo(this, 'change:syndicateId', this.saveToLocalStorage);
    this.listenTo(this, 'change:syndicateId', this.setIsSyndicate);
    this.listenTo(this, "change:rowPrice\n      change:jokerPrice\n      change:drawCount\n      change:selectedDays\n      change:rowPriceMulti\n      change:numberOfValidBoards", this.calculatePrice);
    this.listenTo(this.get('boards'), 'change:price', this.calculatePrice);
    this.listenTo(this.get('boards'), 'change:rowCount', this.setNumberOfValidBoards);
    this.listenTo(this, 'change:jokerRow', this.saveToLocalStorage);
    this.listenTo(this.get('boards'), 'change:board', this.saveToLocalStorage);
    this.listenTo(this.get('tickets'), 'change:quantity', this.saveToLocalStorage);
    this.listenTo(this, 'change:isSubscription change:isSyndicate', (model, value) => this.disableTickets(value));
    this.disableTickets(this.get('isSyndicate') || this.get('isSubscription'));
    this.listenTo(this, 'change:price change:jokerIsValid', this.setValid);
  },
  parse(attrs) {
    var _attrs$boards;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    svs.numbergames.game_model.logger.debug('models.Wager parse', attrs);
    attrs.productId = svs.numbergames.productMapping.getProductId(attrs.productId);
    const rules = options.rules || svs.numbergames.rules.getRules({
      productId: attrs.productId
    });
    rulesRadio.trigger('setRules', rules);
    const collectionOptions = {
      productId: attrs.productId,
      isPackage: attrs.isPackage,
      isSystem: attrs.isSystem,
      noEmptyBoards: options.noEmptyBoards,
      parse: true
    };
    const gameParams = svs.numbergames.game_model.utils.paramParser();
    if (options.storageKey && !Object.entries(gameParams).length) {
      const loadedAttrs = svs.components.Storage.browser.get(options.storageKey, attrs.productId);
      if (loadedAttrs) attrs = loadedAttrs;
    } else if (gameParams.preHuxfluxed) {
      collectionOptions.preHuxfluxed = gameParams.preHuxfluxed;
    }
    if (attrs.jokerPrice) attrs.hasJoker = true;
    if (rules.rowPrice) attrs.rowPrice = rules.rowPrice;
    const isLotto = svs.numbergames.productMapping.isLotto(attrs.productId);
    if (!attrs.isPackage && ((_attrs$boards = attrs.boards) === null || _attrs$boards === void 0 ? void 0 : _attrs$boards.length) > rules.maxNumberOfRows) {
      svs.numbergames.game_model.logger.warn("Got ".concat(attrs.boards.length, " boards but max allowed is ").concat(rules.maxNumberOfRows, ". This should not happen in PROD!"));
      attrs.boards = attrs.boards.splice(0, rules.maxNumberOfRows);
      attrs.numRowsExceedMax = true;
    }

    if (isLotto && attrs.isPackage && gameParams.rowPriceMulti) delete gameParams.rowPriceMulti;
    attrs = _objectSpread(_objectSpread({}, attrs), gameParams);
    if (attrs.drawCount) {
      attrs.isSubscription = attrs.drawCount === 'subscription';
    } else if (attrs.isSubscription) {
      attrs.drawCount = 'subscription';
    }
    attrs.boards = new svs.numbergames.game_model.collections.Boards(attrs.boards, collectionOptions);
    attrs.isSyndicate = Boolean(attrs.syndicateId);
    if (svs.numbergames.productMapping.hasJoker(attrs.productId)) {
      if (attrs.jokerRow) {
        attrs.jokerRow = attrs.jokerRow.map(num => typeof num !== 'object' ? {
          number: num,
          manual: false
        } : num);
      } else {
        attrs.jokerRow = svs.numbergames.rules.joker.getHuxfluxedRow();
      }
    }
    attrs.tickets = new svs.numbergames.game_model.collections.Tickets(attrs.tickets || [], options);
    return attrs;
  },
  drawCountChanged(model, drawCount) {
    this.set({
      isSubscription: drawCount === 'subscription'
    });
  },
  disableTickets(isDisabled) {
    this.get('tickets').disableTickets(isDisabled);
  },
  getJokerRowAsArray() {
    return this.get('jokerRow').map(numObj => numObj.number);
  },
  getJokerRowAsString() {
    return this.getJokerRowAsArray().join('');
  },
  jokerPriceChanged(model, jokerPrice) {
    if (typeof jokerPrice === 'undefined') this.set({
      jokerPrice: 0
    }, {
      silent: true
    });
    this.set({
      hasJoker: Boolean(jokerPrice)
    });
  },
  calculatePrice() {
    let price = this.get('boards').calculatePrice();
    price *= this.get('rowPriceMulti');
    if (price) price += this.get('jokerPrice');
    price *= parseInt(this.get('drawCount'), 10) || 1;
    if (svs.numbergames.productMapping.isProductFamily(this.get('productId'))) price *= this.get('selectedDays').length;
    this.set({
      price
    });
    this.saveToLocalStorage();
  },
  setNumberOfValidBoards() {
    this.set({
      numberOfValidBoards: this.get('boards').getNumberOfValidBoards()
    });
  },
  setValid() {
    this.set({
      isValid: this.checkValid()
    });
  },
  checkValid() {
    if (!this.get('price')) {
      return false;
    }
    const numberOfValidBoards = this.get('boards').getNumberOfValidBoards();
    const isLotto = svs.numbergames.productMapping.isLotto(this.get('productId'));
    if (numberOfValidBoards < 1) {
      return false;
    }
    if (isLotto && !this.get('selectedDays').length) {
      return false;
    }
    if (this.get('hasJoker') && !this.get('jokerIsValid')) return false;
    return true;
  },
  setIsSyndicate() {
    this.set('isSyndicate', Boolean(this.get('syndicateId')));
  },
  setPackage(size) {
    size = parseInt(size, 10);
    const currentPackage = this.get('selectedPackage');
    const packages = this.get('packages');
    const rules = rulesRadio.request('rules');
    const packageRules = rules.PACKAGES[size];

    if (currentPackage) packages[currentPackage] = this.get('boards').models.map(m => m.attributes);
    if (!packageRules || size === currentPackage) return;
    if (!packages[size]) packages[size] = this.get('boards').generatePackageBoards(size);
    this.get('boards').reset(packages[size], {
      isPackage: true
    });
    this.set({
      selectedPackage: size,
      jokerPrice: packageRules.jokerPrice
    });
    this.setNumberOfValidBoards();
  },
  updatePackages() {
    const rules = rulesRadio.request('rules');
    if (rules.PACKAGES[this.get('selectedPackage')]) {
      return;
    }
    const getPackageSizeByRowCount = rowCount => {
      const _Object$entries$find = Object.entries(rules.PACKAGES).find(_ref => {
          let _ref2 = _slicedToArray(_ref, 2),
            packageConfig = _ref2[1];
          return packageConfig.rows === rowCount;
        }),
        _Object$entries$find2 = _slicedToArray(_Object$entries$find, 1),
        size = _Object$entries$find2[0];
      return parseInt(size, 10);
    };
    const selectedPackageBoards = this.get('packages')[this.get('selectedPackage')];
    const selectedPackage = getPackageSizeByRowCount(selectedPackageBoards.length);
    const packages = Object.values(this.get('packages')).reduce((acc, boards) => {
      const size = getPackageSizeByRowCount(boards.length);
      return Object.assign(acc, {
        [size]: boards
      });
    }, {});
    this.set({
      packages,
      selectedPackage
    });
    this.trigger('updated:packages', this);
  },
  saveToLocalStorage() {
    if (this.storageKey) svs.components.Storage.browser.set(this.storageKey, this.get('productId'), this.attributes, svs.components.Storage.constants.EXPIRES_1H);
  },
  removeFromLocalStorage(callback) {
    if (this.storageKey) svs.components.Storage.browser.remove(this.storageKey, this.get('productId'), callback);
  },
  toObject() {
    const attrs = _objectSpread({}, this.attributes),
      validBoards = this.get('boards').getValidBoards();
    attrs.boards = validBoards.map(board => _objectSpread({}, board.attributes));
    return attrs;
  },
  getQuickpickState() {

    const validBoards = this.get('boards').getValidBoards();
    let quickPickState = 0;
    validBoards.forEach(board => {
      let totalLength = board.get('numbers').length;
      let manualLength = board.get('numbers').getManualNumbersLength();
      if (board.has('numbersExtra')) {
        totalLength += board.get('numbersExtra').length;
        manualLength += board.get('numbersExtra').getManualNumbersLength();
      }
      if (manualLength === 0 && quickPickState !== 4) {
        quickPickState = 1;
      } else if (manualLength < totalLength) {
        quickPickState = 4;
      }
    });
    return quickPickState;
  }
});

 })(window);